import Vue from 'vue';
import App from './components/App.vue';
import VueRouter from 'vue-router';
import numberWithCommasMixin from './mixins/numberWithCommasMixin';

import { BootstrapVue } from 'bootstrap-vue';

import './app.scss';

Vue.use(BootstrapVue);
Vue.use(VueRouter);

Vue.config.productionTip = false;

// pages
import Landing from './components/pages/Landing';
import Result from './components/pages/Result';

//for fontawesome icons
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faChevronRight,
  faChevronDown,
  faChevronUp,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faChevronRight, faChevronDown, faChevronUp);

Vue.component('font-awesome-icon', FontAwesomeIcon);
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// `Vue.extend()`, or just a component options object.
// We'll talk about nested routes later.
const routes = [
  { path: '/', component: Landing },
  { path: '/result', component: Result },
];

// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  routes, // short for `routes: routes`
});

//global mixin for adding commas to the number.
Vue.mixin(numberWithCommasMixin);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
